import React from "react";
import "./index.scss";
import { Form, Input, message, Row, Col } from "antd";
import { CancelButton } from "../../../components/CancelButton";
import { businessConsult } from "../api";
import { IPartnerInfo } from "../model";
import * as _ from "lodash";
import { SubmitButton } from "components/SubmitButton";

const cls = "SearchPartnerForm";

type IProps = Readonly<{
  form: any;
  onReset: () => void;
  handleSyncPartnerInfo: (info: IPartnerInfo | null) => void;
}>;

class SearchPartnerForm extends React.Component<IProps> {
  handleReset = () => {
    const { form, onReset } = this.props;
    form.resetFields();
    onReset && onReset();
  };

  handleSubmit = (e: any) => {
    e.preventDefault();
    const { form, handleSyncPartnerInfo } = this.props;

    form.validateFields((err: any, values: any) => {
      if (!err) {
        businessConsult(values).then(res => {
          const { data } = res;
          if (_.isNull(data)) {
            message.info("未查找到合作伙伴！");
            handleSyncPartnerInfo(null);
            return;
          }
          handleSyncPartnerInfo(data);
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form className="SearchPartnerForm" onSubmit={this.handleSubmit}>
        <Row gutter={{ md: 16, xs: 0 }} type="flex" align="bottom">
          <Col xs={24} md={8}>
            <Form.Item
              className="SearchPartnerForm-partnerName"
              label={
                <span className="SearchPartnerForm-label">合作伙伴名称</span>
              }
              colon={false}
            >
              {getFieldDecorator("companyName", {
                rules: [{ required: true, message: "请输入合作伙伴名称" }]
              })(
                <Input
                  placeholder="请输入合作伙伴名称"
                  className="SearchPartnerForm-text-input"
                />
              )}
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
              className="SearchPartnerForm-certificateId"
              label={<span className="SearchPartnerForm-label">证书编号</span>}
              colon={false}
            >
              {getFieldDecorator("certificateNo", {
                rules: [{ required: true, message: "请输入证书编号" }]
              })(
                <Input
                  placeholder="证书编号"
                  className="SearchPartnerForm-text-input certificateId"
                />
              )}
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <div className={`${cls}-buttons`}>
              <SubmitButton text="搜索" htmlType="submit" />
              <CancelButton text="重置" onHandleCancel={this.handleReset} />
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default Form.create<IProps>({})(SearchPartnerForm);
